import * as React from 'react';
import { Group } from 'rcd-cpp-ui/ui/form/Group';
import { EnumInput } from '../../EnumInput/enumInput';
import { WorkspaceRole } from '../../../enums/WorkspaceRole';
import { EditableCriteria, Schema, SchemaField } from '../../../types/Metadata';
import { FieldType } from '../../../enums/FieldType';
import { findOne } from 'rcd-cpp-workspace/utils/array';
import { DataType } from '../../../enums/DataType';

type Props = {
  schema: Schema;
  f: SchemaField;
  onChange: (editableCriteria: EditableCriteria[]) => void;
};

export const PermissionField = ({ schema, f, onChange }: Props) => {
  if (!schema || !f) return null;
  const { field, editableCriteria, fieldType } = f;
  const showPermissionField =
    !f.readOnly &&
    f.dataType != DataType.label &&
    [FieldType.static, FieldType.reference, FieldType.custom].includes(
      fieldType
    );
  if (!showPermissionField) return null;
  let disablePermissionField = false;
  if (schema?.baseSchema?.props?.fields) {
    const baseField = findOne(schema.baseSchema.props.fields, { field });
    if (baseField?.editableCriteria?.length) {
      disablePermissionField = true;
    }
  }
  if (editableCriteria?.length) {
    if (editableCriteria.length > 1) disablePermissionField = true;
    const workspaceRoles = Object.keys(WorkspaceRole);
    for (const ec of editableCriteria) {
      if (ec.dataRefIds?.length) disablePermissionField = true;
      else if (ec.roles?.length) {
        if (ec.roles.filter(r => !workspaceRoles.includes(r)).length > 0) {
          disablePermissionField = true;
        }
      }
    }
  }
  const permissionedRoles =
    (editableCriteria?.length ? editableCriteria[0].roles : []) || [];

  return (
    <Group label="Permissions to Users">
      <EnumInput
        enumValues={WorkspaceRole}
        selected={permissionedRoles}
        onChange={roles => onChange(roles?.length ? [{ roles }] : null)}
        disabled={disablePermissionField}
        multiple
      />
    </Group>
  );
};
